import { Entity } from './../entity';
import { Model } from './model';
export class LaravelEntity {
    public models: Model[] = [];

    constructor() {
        // this.models.push(new Model());
    }
}
